import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ToggleFullscreenDirective } from "./directives/fullscreen.directive";
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { NavService } from './service/nav.service';
import { WINDOW_PROVIDERS } from './service/windows.service';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RightSidebarComponent } from './components/right-sidebar/right-sidebar.component';
import { LoadingComponent } from './components/loading/loading.component';
import { DynamicFormModule } from './dynamic-form/dynamic-form.module';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { AlertComponent } from './components/alert/alert/alert.component';
import { ConfirmComponent } from './components/alert/confirm/confirm.component';
import { PromptComponent } from './components/alert/prompt/prompt.component';
 
@NgModule({
  declarations: [
    ToggleFullscreenDirective,
    FeatherIconsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    ContentLayoutComponent,
    BreadcrumbComponent,
    RightSidebarComponent,
    LoadingComponent,
    MultiSelectDropdownComponent,
    PromptComponent,
    ConfirmComponent,
    AlertComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DynamicFormModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [NavService, WINDOW_PROVIDERS],
  exports: [FeatherIconsComponent, ToggleFullscreenDirective, MultiSelectDropdownComponent]
})
export class SharedModule { }
